import CheckmarkFilled16 from '@carbon/icons-react/es/checkmark--filled/16';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  color: var(--green-50);
`;

export const CheckmarkIcon = (): JSX.Element => {
  return (
    <Wrapper>
      <CheckmarkFilled16 />
    </Wrapper>
  );
};
